<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div
            class="page-title-box d-flex align-items-center justify-content-between"
          >
            <h4 class="mb-0 font-size-18">Create {{ module }}</h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'dashboards' }"
                    >Dashboards</router-link
                  >
                </li>
                <li class="breadcrumb-item">
                  <router-link :to="{ name: table_module }">{{
                    module
                  }}</router-link>
                </li>
                <li class="breadcrumb-item active">Create</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        hide-footer
        id="modal-customers"
        ref="modal-customers"
        title="Tambah Pelanggan"
      >
        <form class="form-sample" @submit.prevent="saveCustomers()">
          <div class="row">
            <div
              class="col-md-12"
              v-for="(item, index) in fields_customers"
              :key="index"
            >
              <div class="form-group">
                <label>{{ item["usr_f_label"] }}</label>
                <small
                  v-if="item['usr_f_validation'] !== '' && item['usr_f_validation'] !== null"
                  class="pull-right text-danger"
                  >*{{ item["usr_f_validation"] }}</small
                >
                <component
                  :is="item['usr_f_input_type'] + '_form'"
                  :name="item['usr_f_name']"
                  :validation="item['usr_f_validation']"
                  :content="item['content']"
                  :dropdown_name="item['usr_f_options']"
                  @post="bindingDataCustomers"
                ></component>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary mr-2">Submit</button>
          <button type="button" class="btn btn-danger mr-2" @click="hideModal">
            Batal
          </button>
        </form>
      </b-modal>

      <b-modal
        hide-footer
        id="modal-customers-cars"
        ref="modal-customers-cars"
        title="Tambah Mobil Pelanggan"
      >
        <form class="form-sample" @submit.prevent="saveCustomersCars()">
          <div class="row">
            <div
              class="col-md-12"
              v-for="(item, index) in fields_customers_cars"
              :key="index"
            >
              <div class="form-group">
                <label>{{ item["cst_crs_f_label"] }}</label>
                <small
                  v-if="item['cst_crs_f_validation'] != ''"
                  class="pull-right text-danger"
                  >*{{ item["cst_crs_f_validation"] }}</small
                >
                <component
                  :is="item['cst_crs_f_input_type'] + '_form'"
                  :name="item['cst_crs_f_name']"
                  :validation="item['cst_crs_f_validation']"
                  :content="item['content']"
                  :dropdown_name="item['cst_crs_f_options']"
                  @post="bindingDataCustomersCars"
                  :parsing-post="post_customers_cars"
                  :parsing-trigger="trigger_autocomplete"
                ></component>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary mr-2">Submit</button>
          <button
            type="button"
            class="btn btn-danger mr-2"
            @click="hideModalCustomersCars"
          >
            Batal
          </button>
        </form>
      </b-modal>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-7">
          <div class="card">
            <div class="card-body">
              <!-- Tab index 0 => services; 1 => services_package; 2 => products  -->
              <b-tabs v-model="tabIndex" content-class="mt-3" fill>
                <b-tab
                  title="Regular Servis"
                  @click="changeType(0)"
                  id="services"
                >        
                  <template v-if="data_srv != null">       
                    <div class="form-group mb-0 mt-4">
                      <b-form-input v-model="searchSrvName" @input="runServices" placeholder="Search services name..." type="text"></b-form-input>
                    </div>
                  </template>

                  <template v-if="data_srv == null">
                    <h5>Please select customers and cars</h5>
                  </template>
                  <template v-else-if="data_srv.length > 0">
                    <div class="mt-3">
                      <div class="row vld-parent">
                        <loading :active.sync="isLoadingSrv" :is-full-page="false"></loading>
                        <div
                          class="col-md-6"
                          v-for="(item, index_srv) in data_srv"
                          :key="index_srv"
                        >
                          <div class="card shadow-sm mb-2">
                            <div class="card-body">
                              <div class="mb-2 justify-content-between d-flex">
                                <div>
                                  <h5 class="font-size-15">
                                    <a href="javascript:;" class="text-dark">{{
                                      item.srv_name
                                    }}</a>
                                  </h5>
                                </div>
                                <div class="form-check mr-2">
                                  <input
                                    class="form-check-input mx-0"
                                    type="checkbox"
                                    v-model="bindCheckOut.services"
                                    :value="item"
                                    :id="'srv_checkbox_' + index_srv"
                                    @change="getTotalPrice()"
                                  />
                                  <label
                                    class="form-check-label mx-0"
                                    :for="'srv_checkbox_' + index_srv"
                                  ></label>
                                </div>
                              </div>

                              <p class="font-size-12 text-muted">
                                {{
                                  item.srv_description != null
                                    ? item.srv_description
                                    : "-"
                                }}
                              </p>

                              <div class="d-flex justify-content-between">
                                <div class>
                                  <h5 class="font-size-12 text-muted">Price</h5>
                                  <p class="font-size-12 text-primary mb-0">
                                    <b
                                      >Rp
                                      {{
                                        $root.numberWithCommas(item.srv_price)
                                      }}</b
                                    >
                                  </p>
                                </div>
                                <div class="text-right">
                                  <h5 class="font-size-12 text-muted">
                                    Estimate Durations
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ est_time(item.srv_time) }}
                                    <i
                                      class="bx bx-calendar-check ml-1 text-primary"
                                    ></i>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="d-flex align-items-center w-100 bg-light mb-3 h-350 mt-3"
                    >
                      <div class="m-auto text-center mini-stats-wid">
                        <div
                          class="mini-stat-icon avatar-sm rounded-circle bg-secondary m-auto"
                        >
                          <span class="avatar-title">
                            <i class="bx bx-search-alt font-size-2"></i>
                          </span>
                        </div>
                        <h5 class="mt-3">Data Empty</h5>
                      </div>
                    </div>
                  </template>

                  <div class="row">
                    <div class="col-lg-12" v-if="total_page_srv > 1">
                      <paginate
                        v-model="page_srv"
                        :pageCount="parseInt(total_page_srv)"
                        :initial-page="page_srv"
                        :click-handler="startPaginateSrv"
                        prevText="<i class='mdi mdi-chevron-left'></i>"
                        nextText="<i class='mdi mdi-chevron-right'></i>"
                        container-class="pagination pagination-rounded justify-content-center mt-4"
                        pageClass="page-item"
                        page-link-class="page-link"
                        prev-class="page-item"
                        prev-link-class="page-link"
                        next-class="page-item"
                        next-link-class="page-link"
                      ></paginate>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Servis Paket" @click="changeType(1)">
                  <template v-if="data_srv_b != null">       
                    <div class="form-group mb-0 mt-4">
                      <b-form-input v-model="searchSrvBName" @input="runServices" placeholder="Search services package name..." type="text"></b-form-input>
                    </div>
                  </template>

                  <template v-if="data_srv_b == null">
                    <h5>Please select customers and cars</h5>
                  </template>

                  <template v-else-if="data_srv_b.length > 0">
                    <div class="mt-3">
                      <div class="row vld-parent">
                        <loading :active.sync="isLoadingSrvB" :is-full-page="false"></loading>
                        <div
                          class="col-md-12"
                          v-for="(item, index_srv_b) in data_srv_b"
                          :key="index_srv_b"
                        >
                          <div class="card shadow-sm mb-2">
                            <div class="card-body">
                              <div class="mb-2 justify-content-between d-flex">
                                <div>
                                  <h5 class="font-size-15">
                                    <a href="javascript:;" class="text-dark">{{
                                      item.srv_b_name
                                    }}</a>
                                  </h5>
                                </div>
                                <div class="form-check mr-2">
                                  <input
                                    class="form-check-input mx-0"
                                    type="checkbox"
                                    v-model="bindCheckOut.services_bulk"
                                    :value="item"
                                    :id="'srv_b_checkbox_' + index_srv_b"
                                    @change="getTotalPrice()"
                                  />
                                  <label
                                    class="form-check-label mx-0"
                                    :for="'srv_b_checkbox_' + index_srv_b"
                                  ></label>
                                </div>
                              </div>

                              <template v-if="item.srv_b_description != '' && item.srv_b_description != null">
                                <read-more
                                  more-str="Read More"
                                  :text="item.srv_b_description"
                                  link="#"
                                  less-str="Read Less"
                                  :maxChars="350"
                                ></read-more>
                              </template>
                              <p class="font-size-12 text-muted" v-else>
                                -
                              </p>

                              <div class="d-flex justify-content-between">
                                <div class>
                                  <h5 class="font-size-12 text-muted">Price</h5>
                                  <p class="font-size-12 text-primary mb-0">
                                    <b
                                      >Rp
                                      {{
                                        $root.numberWithCommas(item.srv_b_price)
                                      }}</b
                                    >
                                  </p>
                                </div>
                                <div class="text-right">
                                  <h5 class="font-size-12 text-muted">
                                    Estimate Durations
                                  </h5>
                                  <p class="text-muted mb-0">
                                    {{ est_time(item.srv_b_time) }}
                                    <i
                                      class="bx bx-calendar-check ml-1 text-primary"
                                    ></i>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="d-flex align-items-center w-100 bg-light mb-3 h-350 mt-3"
                    >
                      <div class="m-auto text-center mini-stats-wid">
                        <div
                          class="mini-stat-icon avatar-sm rounded-circle bg-secondary m-auto"
                        >
                          <span class="avatar-title">
                            <i class="bx bx-search-alt font-size-2"></i>
                          </span>
                        </div>
                        <h5 class="mt-3">Data Empty</h5>
                      </div>
                    </div>
                  </template>

                  <div class="row">
                    <div class="col-lg-12" v-if="total_page_srv_b > 1">
                      <paginate
                        v-model="page_srv_b"
                        :pageCount="parseInt(total_page_srv_b)"
                        :initial-page="page_srv_b"
                        :click-handler="startPaginateSrvB"
                        prevText="<i class='mdi mdi-chevron-left'></i>"
                        nextText="<i class='mdi mdi-chevron-right'></i>"
                        container-class="pagination pagination-rounded justify-content-center mt-4"
                        pageClass="page-item"
                        page-link-class="page-link"
                        prev-class="page-item"
                        prev-link-class="page-link"
                        next-class="page-item"
                        next-link-class="page-link"
                      ></paginate>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Produk" @click="changeType(2)">
                  <template v-if="data_prd != null">    
                    <div class="form-group mb-0 mt-3">
                      <input
                        class="form-control"
                        v-model="searchProductsName"
                        @input="runServices"
                        type="text"
                        placeholder="Search here..."
                      />
                    </div>
                  </template>

                  <template v-if="data_prd == null">
                    <h5>Please select customers and cars</h5>
                  </template>
                  <template v-else-if="data_prd.length > 0">
                    <div class="mt-3">
                      <div
                        class="card shadow-sm mb-2"
                        v-for="(item, index_data_prd) in data_prd"
                        :key="index_data_prd + random_num"
                      >
                        <div class="card-body">
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <div class="d-flex align-items-center">
                              <template
                                v-if="item.prd_image !== undefined"
                              >
                                <img
                                  v-if="item.prd_image.length > 0"
                                  class="rounded-circle details-employee-user mr-3"
                                  :src="
                                    $root.backEnd +
                                    item.prd_image[0].prd_r_img_name
                                  "
                                  alt="Header Avatar"
                                />
                              </template>
                              <div class>
                                <small class="text-muted">{{
                                  item.prd_sku
                                }}</small>
                                <h5 class="font-size-15">
                                  <a href="#" class="text-dark">{{
                                    item.prd_name
                                  }}</a>
                                </h5>
                                <!-- <router-link
                                  v-for="(item_crs, index_crs) in item.crs_model_id" :key="index_crs"
                                  :to="{
                                    name: 'cars_model_detail',
                                    params: { uuid: item_crs['crs_model_uuid'] },
                                }">
                                  {{ item_crs.crs_model_name }}
                                  <template v-if="item.crs_model_id.length != index_crs + 1">
                                    ,
                                  </template>
                                </router-link> -->
                              </div>
                            </div>
                            <div class="form-check mr-2 mb-0">
                              <input
                                class="form-check-input mx-0"
                                type="checkbox"
                                v-model="bindCheckOut.products"
                                :value="item"
                                :id="'srv_products_' + index_data_prd"
                                @change="getTotalPrice()"
                              />
                              <label
                                class="form-check-label mx-0"
                                :for="'srv_products_' + index_data_prd"
                              ></label>
                            </div>
                          </div>
                          <hr />
                          <div
                            class="justify-content-between d-flex align-items-center mt-3"
                          >
                            <div class>
                              <h5 class="font-size-12 text-muted">Category</h5>
                              <p class="font-size-12 mb-0">
                                {{ item.prd_c_name }}
                              </p>
                            </div>
                            <div class>
                              <h5 class="font-size-12 text-muted">Brand</h5>
                              <p class="font-size-12 mb-0">
                                {{ item.brd_name }}
                              </p>
                            </div>
                            <div class>
                              <h5 class="font-size-12 text-muted">Stock</h5>
                              <p class="font-size-12 mb-0">
                                <b>{{ item.prd_stock+' '+item.prd_unit }}</b>
                              </p>
                            </div>
                            <div class>
                              <h5 class="font-size-12 text-muted">Price</h5>
                              <p class="font-size-12 text-primary mb-0">
                                <b
                                  >Rp
                                  {{
                                    $root.numberWithCommas(item.prd_purchase)
                                  }}</b
                                >
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-12" v-if="total_page_prd > 1">
                        <paginate
                          v-model="page_prd"
                          :pageCount="parseInt(total_page_prd)"
                          :initial-page="page_prd"
                          :click-handler="startPaginatePrd"
                          prevText="<i class='mdi mdi-chevron-left'></i>"
                          nextText="<i class='mdi mdi-chevron-right'></i>"
                          container-class="pagination pagination-rounded justify-content-center mt-4"
                          pageClass="page-item"
                          page-link-class="page-link"
                          prev-class="page-item"
                          prev-link-class="page-link"
                          next-class="page-item"
                          next-link-class="page-link"
                        ></paginate>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="d-flex align-items-center w-100 bg-light mb-3 h-350 mt-3"
                    >
                      <div class="m-auto text-center mini-stats-wid">
                        <div
                          class="mini-stat-icon avatar-sm rounded-circle bg-secondary m-auto"
                        >
                          <span class="avatar-title">
                            <i class="bx bx-search-alt font-size-2"></i>
                          </span>
                        </div>
                        <h5 class="mt-3">Data Empty</h5>
                      </div>
                    </div>
                  </template>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <form @submit.prevent="submit()">
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <h4 class="card-title mb-0">Customers</h4>
                  <b-button
                    type="button"
                    class="btn btn-secondary waves-effect waves-light btn-sm right-bar-toggle"
                    @click="getFieldsCustomers"
                    v-b-modal.modal-customers
                  >
                    <i class="bx bx-plus mr-2"></i> New
                  </b-button>
                </div>
                <div class="form-group mb-0 mt-2">
                  <!-- <v-select
                    label="usr_fullname"
                    :options="options_customers"
                    :filterable="false"
                    v-model="data_customers"
                    @search="searchAutocompleteCustomers"
                    @input="triggerCustomersCars"
                  >
                    <template #no-options>please type customers</template>
                  </v-select> -->
                  <!-- <br> -->
                  <!-- <input type="text" class="form-control" @input="search_cst">
                  <input type="text" class="form-control" @input="search_cst"> -->

                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <!-- <label for="searchCstFullName">Nama</label> -->
                    <input type="text" class="form-control" placeholder="Nama" id="searchCstFullName" autocomplete="off" @input="search_cst" v-model="searchCustomers.usr_fullname">
                  </div>
                  <div class="form-group col-md-6">
                    <!-- <label for="searchCstPhone">Phone</label> -->
                    <input type="text" class="form-control" placeholder="Phone" id="searchCstPhone" autocomplete="off" @input="search_cst" v-model="searchCustomers.usr_phone">
                  </div>
                </div>

                <div class="card">
                  <div class="card-header bg-warning">
                    <h4 class="card-title mb-0 text-white">Data Customers</h4>
                  </div>
                  <div class="card-body content-board pt-0 px-0" id="searchCustomersView" style="max-height : 500px; overflow : auto;">
                    <!-- <loading :active.sync="loadingMenungguPembayaran" :height="30" :width="40" color="#398bd7" :is-full-page="false"></loading> -->
                    <input type="text" class="form-control form-control-sm" placeholder="Cari Nomor Polisi" @input="search_cst" v-model="searchCustomers.police_number">
                    <ul class="list-group list-group-flush mt-1">
                      <li
                        class="list-group-item list-group-item-action"
                        style="cursor : pointer"
                        v-for="(item, index) in options_customers.data" :key="index+'options_customers'"
                        @click="data_customers = item; triggerCustomersCars()"
                      >
                        <div class="d-flex align-items-center justify-content-between">
                          <strong class="mb-0">{{ item.usr_fullname }}</strong>
                        </div>
                        <h6 class="list-title mb-0">{{item.usr_phone}}</h6>
                        <br>
                        <p v-for="cars in item.cars" :key="cars.cst_crs_uuid">
                          <span>-
                            <template v-if="cars.crs_brand_name !== null">
                              {{ cars.crs_brand_name }}
                            </template>
                            <template v-if="cars.crs_model_name !== null">
                              {{ cars.crs_model_name }}
                            </template>
                            <template v-if="cars.cst_crs_police_number !== null">
                              ({{ cars.cst_crs_police_number }})
                            </template>                          
                          </span>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  class="d-flex align-items-center w-100 bg-light mt-3 h-100"
                  v-if="data_customers.length == 0"
                >
                  <div class="m-auto text-center mini-stats-wid">
                    <h5 class="mt-3">Choose Customers</h5>
                  </div>
                </div>

                <div class="card border mt-2 mb-0" v-else>
                  <div class="card-body">
                    <div class="justify-content-between d-flex mb-3">
                      <div class="d-flex align-items-center">
                        <img
                          v-if="data_customers.usr_photo == null"
                          class="rounded-circle details-employee-user mr-3"
                          src="@/assets/user.png"
                          alt="Header Avatar"
                        />
                        <img
                          v-else
                          class="rounded-circle details-employee-user mr-3"
                          :src="$root.backEnd + data_customers.usr_photo"
                          alt="Header Avatar"
                        />
                        <div>
                          <h5 class="mb-1 font-size-15">
                            {{ data_customers.usr_fullname }}
                          </h5>
                          <span
                            href="#"
                            class="text-muted text-truncate-employee"
                            >{{ data_customers.usr_email }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="form-group mb-0">
                      <label>Choose Car</label>
                      <b-button
                        type="button"
                        class="btn btn-secondary waves-effect waves-light btn-sm ml-5"
                        @click="getFieldsCustomersCars"
                        v-b-modal.modal-customers-cars
                      >
                        <i class="bx bx-plus mr-2"></i> New
                      </b-button>
                      <hr />
                      <select
                        required
                        v-model="post.cst_crs_id"
                        class="form-control form-control-sm"
                        @change="runServicesWithFilter"
                      >
                        <option
                          v-for="(item, index_data_cars) in data_cars"
                          :key="index_data_cars"
                          :value="item['cst_crs_id']"
                        >
                          {{ item.crs_brand_name }}
                          {{ item["crs_model_name"] }} ({{
                            item["cst_crs_police_number"] != null
                              ? item["cst_crs_police_number"]
                              : " - "
                          }})
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-0">Check Out</h4>
                <!-- kalo kosong datanya pake ini -->
                <div
                  class="d-flex align-items-center w-100 bg-light mt-3 h-100"
                  v-if="
                    bindCheckOut.services.length == 0 &&
                    bindCheckOut.services_bulk.length == 0 &&
                    bindCheckOut.products.length == 0
                  "
                >
                  <div class="m-auto text-center mini-stats-wid">
                    <h5 class="mt-3">Not Found</h5>
                  </div>
                </div>

                <template v-if="bindCheckOut.services.length > 0">
                  <h5 class="font-size-15 mt-3">
                    <a href="#" class="text-dark">Service</a>
                  </h5>

                  <div class="table-responsive">
                    <table class="table table-centered table-striped table-bordered table-nowrap mb-0">
                      <thead class="thead-dark">
                        <tr>                        
                          <th style="width: 50px;"></th>
                          <th>
                            <div class="d-flex align-items-center justify-content-between">
                              Servis
                            </div>
                          </th>
                          <th>
                            <div class="d-flex align-items-center justify-content-between">
                              Harga (Rp)
                            </div>
                          </th>
                          <th>
                            <div class="d-flex align-items-center justify-content-between">
                              Estimasi
                            </div>
                          </th>
                          <th>
                            <div class="d-flex align-items-center justify-content-between">
                              Supplier
                            </div>
                          </th>
                          <th>
                            <div class="d-flex align-items-center justify-content-between">
                              Harga Supplier
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index_services) in bindCheckOut.services"
                          :key="index_services">
                          <td>
                            <button type="button" @click="removeDataCheckout('services', index_services, item)" class="btn btn-link btn-rounded waves-effect"><i class="bx bx-trash"></i></button>
                          </td>
                          <td>{{ item.srv_name }}</td>
                          <td>
                            <div style="display: inline-block; min-width:150px">
                              <money
                                name="srv_price"
                                :class="'form-control'+((readOnlyNotAdmin) ? ' readonly' : '')"
                                placeholder="Type here"
                                v-bind="money"
                                v-model="item.srv_act_price"
                                :readonly="readOnlyNotAdmin"
                                @input="
                                  addVarBindChekcOut(
                                    $event,
                                    item.srv_id,
                                    'services',
                                    'srv_act_price'
                                  )
                                "
                              ></money>
                            </div>
                          </td>
                          <td><i
                              class="bx bx-calendar-check ml-1 text-primary"
                            ></i> {{ est_time(item.srv_time) }}</td>
                          <td>
                            <template v-if="item.spr_id !== undefined">
                              <div style="display: inline-block; min-width:150px">
                                <select
                                  class="form-control"
                                  v-model="item.spr_id_select"
                                  @change="
                                    selectSupplier(
                                      $event,
                                      index_services,
                                      'services',
                                      item
                                    )
                                  "
                                >
                                  <option
                                    :value="item_spr.spr_id"
                                    v-for="(item_spr, index_spr) in item.spr_id"
                                    :key="index_spr"
                                  >
                                    {{ item_spr.spr_name }}
                                  </option>
                                </select>
                              </div>
                            </template>
                            <template v-else>
                              <p class="text-muted mb-0 font-weight-bold">
                                Supplier Not Found
                              </p>
                            </template>
                          </td>
                          <td>
                            <template
                              v-if="
                                item.srv_price_est_external !== undefined &&
                                item.srv_price_est_external !== null
                              "
                            >
                              <div style="display: inline-block; min-width:150px">
                                <money
                                  name="srv_price"
                                  :class="'form-control'+((readOnlyNotAdmin) ? ' readonly' : '')"
                                  class="form-control"
                                  placeholder="Type here"
                                  v-bind="money"
                                  v-model="item.srv_price_act_external"
                                  :readonly="readOnlyNotAdmin"
                                  @input="
                                    addVarBindChekcOut(
                                      $event,
                                      item.srv_id,
                                      'services',
                                      'srv_price_act_external'
                                    )
                                  "
                                ></money>
                              </div>
                            </template>
                            <template v-else>
                              -
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
                <template v-if="bindCheckOut.services_bulk.length > 0">
                  <h5 class="font-size-15 mt-3">
                    <a href="#" class="text-dark">Servis Paket</a>
                  </h5>
                  
                  <div class="table-responsive">
                    <table class="table table-centered table-striped table-bordered table-nowrap mb-0">
                      <thead class="thead-dark">
                        <tr>                        
                          <th style="width: 50px;"></th>
                          <th>
                            <div class="d-flex align-items-center justify-content-between">
                              Servis
                            </div>
                          </th>
                          <th>
                            <div class="d-flex align-items-center justify-content-between">
                              Harga (Rp)
                            </div>
                          </th>
                          <th>
                            <div class="d-flex align-items-center justify-content-between">
                              Estimasi
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item,
                          index_services_bulk) in bindCheckOut.services_bulk"
                          :key="index_services_bulk + random_num">
                          <td>
                            <button type="button" @click="
                              removeDataCheckout(
                                'services_bulk',
                                index_services_bulk,
                                item
                              )
                            " class="btn btn-link btn-rounded waves-effect"><i class="bx bx-trash"></i></button>
                          </td>
                          <td>{{ item.srv_b_name }}</td>
                          <td>
                            <div style="display: inline-block; min-width:150px">
                              <money
                                name="srv_b_price"
                                :class="'form-control'+((readOnlyNotAdmin) ? ' readonly' : '')"
                                placeholder="Type here"
                                v-bind="money"
                                v-model="item.srv_b_act_price"
                                :readonly="readOnlyNotAdmin"
                                @input="
                                  addVarBindChekcOut(
                                    $event,
                                    item.srv_b_id,
                                    'services_bulk',
                                    'srv_b_act_price'
                                  )
                                "
                              ></money>
                            </div>
                          </td>
                          <td><i
                              class="bx bx-calendar-check ml-1 text-primary"
                            ></i> {{ est_time(item.srv_b_time) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
                <template v-if="bindCheckOut.products.length > 0">
                  <h5 class="font-size-15 mt-3">
                    <a href="#" class="text-dark">Products</a>
                  </h5>
                  <div class="table-responsive">
                    <table class="table table-centered table-striped table-bordered table-nowrap mb-0">
                      <thead class="thead-dark">
                        <tr>                        
                          <th style="width: 50px;"></th>
                          <th>
                            <div class="d-flex align-items-center justify-content-between">
                              Nama Produk
                            </div>
                          </th>
                          <th>
                            <div class="d-flex align-items-center justify-content-between">
                              Harga (Rp)
                            </div>
                          </th>
                          <th>
                            <div class="d-flex align-items-center justify-content-between">
                              Quantitiy
                            </div>
                          </th>
                          <th>
                            <div class="d-flex align-items-center justify-content-between">
                              Total (Rp)
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index_prd) in bindCheckOut.products"
                          :key="'checkout_products_' + index_prd + random_num">
                          <td>
                            <button type="button" @click="removeDataCheckout('products', index_prd, item)" class="btn btn-link btn-rounded waves-effect"><i class="bx bx-trash"></i></button>
                          </td>
                          <td>{{ item.prd_name }}</td>
                          <td>
                            <div style="display: inline-block; min-width:150px">
                              <money
                                name="prd_act_price"
                                :class="'form-control'+((readOnlyNotAdmin) ? ' readonly' : '')"
                                placeholder="Type here"
                                v-bind="money"
                                v-model="item.prd_act_price"
                                :readonly="readOnlyNotAdmin"
                                @input="
                                  addVarBindChekcOut(
                                    $event,
                                    item.prd_id,
                                    'products',
                                    'prd_act_price'
                                  )
                                "
                              ></money>
                            </div>
                          </td>
                          <td>
                            <vue-number-input
                              v-model="item.prd_qty"
                              :min="1"
                              :max="item.prd_stock"
                              size="small"
                              :inputtable="false"
                              inline
                              center
                              controls
                              @input="
                                addVarBindChekcOut(
                                  $event,
                                  item.prd_id,
                                  'products',
                                  'prd_qty'
                                )
                              "
                            ></vue-number-input>
                          </td>
                          <td>
                            <p class="text-muted mb-0 font-weight-bold">
                              Rp {{ $root.numberWithCommas(item.prd_total_price) }}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-between">
                  <h4 class="card-title mb-0">Teknisi</h4>
                </div>
                <div class="form-group mb-0 mt-2">
                  <s_autocomplete_form
                    name="emp_id"
                    :table_module="table_module"
                    :validation="empRequired"
                    dropdown_name="emp_id"
                    @post="bindingData"
                  ></s_autocomplete_form>
                </div>

                <template v-if="post.emp_id === undefined">
                  <div
                    class="d-flex align-items-center w-100 bg-light mt-3 h-100"
                  >
                    <div class="m-auto text-center mini-stats-wid">
                      <h5 class="mt-3">Choose Your Teknisi</h5>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <div class="card border mt-2 mb-0">
                    <div class="card-body">
                      <div class="justify-content-between d-flex">
                        <div class="d-flex align-items-center">
                          <img
                            class="rounded-circle details-employee-user mr-3"
                            src="@/assets/user.png"
                            alt="Header Avatar"
                          />
                          <div>
                            <h5 class="mb-1 font-size-15">
                              {{ data_emp.emp_name }}
                            </h5>
                            <span
                              href="#"
                              class="text-muted text-truncate-employee"
                              >{{
                                data_emp.emp_phone != null
                                  ? data_emp.emp_phone
                                  : "-"
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <div class="card border mt-2 mb-0">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>Kilometer</label>
                      <money
                        name="srv_t_km"
                        class="form-control"
                        placeholder="Type here"
                        v-bind="money_no_rp"
                        v-model="post.srv_t_km"
                      ></money>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label>DP</label>
                      <money
                        name="srv_t_dp"
                        :class="'form-control'+((readOnlyNotAdmin) ? ' readonly' : '')"
                        placeholder="Type here"
                        v-bind="money"
                        v-model="post.srv_t_dp"
                        @input="getTotalPrice()"
                        :readonly="readOnlyNotAdmin"
                      ></money>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label>Total Harga</label>
                      <money
                        name="srv_t_dp"
                        :class="'form-control'+((readOnlyNotAdmin) ? ' readonly' : '')"
                        placeholder="Type here"
                        v-bind="money"
                        v-model="post.srv_t_actual_price"
                        :readonly="readOnlyNotAdmin"
                      ></money>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label>Catatan / Keluhan</label>
                      <textarea
                        v-model="post.srv_t_note_users"
                        class="form-control"
                        type="text"
                        rows="3"
                        placeholder="Type here..."
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label>Notes</label>
                      <textarea
                        v-model="post.srv_t_note"
                        class="form-control"
                        type="text"
                        rows="3"
                        placeholder="Type here..."
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="d-flex align-items-center justify-content-end my-4 border-top"
            >
              <router-link class="btn btn-secondary w-50" :to="{name:table_module}">Cancel</router-link>
              <b-button
                type="submit"    
                variant="primary"
                class="btn btn-primary ml-2 w-50"
                :disabled="disabled"
              >
                <template v-if="disabled">
                  <b-spinner small type="grow"></b-spinner>
                  Loadung ..
                </template>
                <template v-else>
                  Save
                </template>
              </b-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import text_form from "@/components/input/text";
import longtext_form from "@/components/input/longtext";
import number_form from "@/components/input/number";
import option_form from "@/components/input/option";
import s_autocomplete_form from "@/components/input/single_autocomplete";
import m_autocomplete_form from "@/components/input/multiple_autocomplete";
import phone_form from "@/components/input/phone";
import time_form from "@/components/input/time";
import datetime_form from "@/components/input/datetime";
import money_form from "@/components/input/money";
import email_form from "@/components/input/email";
import year_form from "@/components/input/year";
import s_image_form from "@/components/input/s_image";
import VueNumberInput from "@chenfengyuan/vue-number-input";
import { Money } from "v-money";
import multiplegroup_autocomplete_form from "@/components/input/multiplegroup_autocomplete";

export default {
  data() {
    return {
      module: "Transaksi Servis",
      table_module: "services_transaction",
      alias_table: "srv_t",
      bindCheckOut: {
        services: [],
        services_bulk: [],
        products: [],
        products_by_services: [],
      },
      page_srv: 1,
      limit: 10,
      totalData_srv: 0,
      total_page_srv: 0,
      page_srv_b: 1,
      totalData_srv_b: 0,
      total_page_srv_b: 0,
      page_prd: 1,
      totalData_prd: 0,
      total_page_prd: 0,
      money: {
        thousands: ".",
        prefix: "Rp ",
        precision: 0,
      },
      money_no_rp : {
        thousands: ".",
        prefix: "",
        precision: 0,
      },
      data_emp: {},
      fields: {},
      fields_customers: {},
      fields_customers_cars: {},
      post: {
        srv_t_actual_price: 0,
        srv_t_estimated_price: 0,
        srv_t_dp: 0,
        srv_t_cat: 4,
        srv_t_status: 3,
        srv_t_km : ""
      },
      post_customers: {},
      post_customers_cars: {},
      options_cars: [],
      options: [],
      options_customers: [],
      options_employe: [],
      list: [],
      data_cars: [],
      data_autocomplete: [],
      data_customers: [],
      data_employe: [],
      dd_label: "",
      dd_value: "",
      data_srv: null,
      trigger_autocomplete: "",
      model_cars: "",
      data_srv_b: null,
      data_prd: null,
      tabIndex: 0,
      searchProductsName: null,
      searchSrvName: null,
      searchSrvBName: null,
      isLoadingSrv: false,
      isLoadingSrvB: false,
      isLoadingPrd: false,
      disabled : false,
      page_customers : 1,
      searchCustomers : {}
    };
  },
  computed: {
    local_users() {
      if (localStorage.getItem("users") != undefined) {
        return JSON.parse(localStorage.getItem("users"));
      }
      return {};
    },
    sumTotal() {
      // var vm = this;
      var type = this.getType();
      var total = 0;
      this.list.forEach(function (v) {
        total += v[type + "_price"];
      });

      return total;
    },
    empRequired: function(){
      var res = null

      if (
        this.bindCheckOut.services.length > 0 ||
        this.bindCheckOut.services_bulk.length > 0
      ) {
        res = 'required'
      }

      return res
    },
    readOnlyNotAdmin(){
      let result = true;

      if(this.local_users.usr_admin != '')
      {
        result = false;
      }

      return result;
    },
  },
  components: {
    text_form,
    longtext_form,
    number_form,
    option_form,
    s_autocomplete_form,
    phone_form,
    time_form,
    datetime_form,
    money_form,
    m_autocomplete_form,
    email_form,
    year_form,
    s_image_form,
    Money,
    VueNumberInput,
    multiplegroup_autocomplete_form
  },
  mounted() {
    let that = this;
    // Detect when scrolled to bottom.
    const listElm = document.querySelector('#searchCustomersView');
    if (listElm != null) 
    {
      listElm.addEventListener('scroll', function(){
        if(listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          // console.log('okok');
          that.loadMoreSearchCst();
        }
      });
    }
  },
  methods: {
    getTotalPrice: function () {
      var res = 0;
      if (this.bindCheckOut.products.length > 0) {
        this.bindCheckOut.products.forEach((element) => {
          res += element.prd_total_price;
        });
      }

      if (this.bindCheckOut.services.length > 0) {
        this.bindCheckOut.services.forEach((element) => {
          res += element.srv_act_price;
        });
      }

      if (this.bindCheckOut.services_bulk.length > 0) {
        this.bindCheckOut.services_bulk.forEach((element) => {
          res += element.srv_b_act_price;
        });
      }

      var total = res - this.post.srv_t_dp;
      this.$set(this.post, "srv_t_actual_price", total);
      this.$set(this.post, "srv_t_estimated_price", total);
    },
    triggerCustomersCars() {
      this.searchCustomers = {};
      this.options_customers = [];
      this.$set(this.post, "cst_id", this.data_customers.usr_id);
      this.$set(this.post_customers_cars, "cst_id", this.data_customers.usr_id);
      this.getCustomersCars();
    },
    getCustomersCars() {
      var params = {};
      params = {
        ["filter[cst_id]"]: this.data_customers.usr_id,
      };

      this.axios
        .get("/dropdown/option/cst_cars_id", { params: params })
        .then((response) => {
          this.data_cars = response.data.data.data;
        });
    },
    searchAutocompleteCustomers(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.search_cst(loading, search, this);
      }
    },
    search: _.debounce((loading, search, vm) => {
      var params = {};
      params = {
        ["search[crs_model_name]"]: search,
      };

      vm.axios
        .get("/dropdown/autocomplete/crs_model_id", { params: params })
        .then((response) => {
          loading(false);
          vm.options_cars = response.data.data.data;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 500),
    search_cst: _.debounce( function(){
      var params = {};
      params["usr_fullname"] = this.searchCustomers.usr_fullname;
      params["usr_phone"] = this.searchCustomers.usr_phone;
      params["police_number"] = this.searchCustomers.police_number;
      params["page"] = this.page_customers;

      this.axios.post("/customers_cars/search_customers", params)
        .then((response) => {
          this.options_customers = response.data.data;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 500),
    loadMoreSearchCst : function(){
      if(this.options_customers.total_page <= this.page_customers)
      {
        return false;
      }

      var params = {};
      params["usr_fullname"] = this.searchCustomers.usr_fullname;
      params["usr_phone"] = this.searchCustomers.usr_phone;
      params["police_number"] = this.searchCustomers.police_number;
      params["page"] = this.page_customers + 1;

      this.axios.post("/customers_cars/search_customers", params)
        .then((response) => {
          this.page_customers = response.data.data.current_page;
          let data = response.data.data.data;
          data.forEach(element=> {
            this.options_customers.data.push(element)
          });
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    },
    changeType(evt) {
      this.tabIndex = evt;
      // this.list = [];
      this.runServices();

      delete this.post["srv_id"];
      delete this.post["srv_b_id"];
    },
    deleteList(k) {
      this.list.splice(k, 1);
    },
    runServicesWithFilter() {
      this.runServices();
    },
    runServices : _.debounce(function(){
      var params = {};
      var met = "";

      if (this.tabIndex == 0) {
        this.isLoadingSrv = true;
        params = {
          ["search[srv_name]"]: this.searchSrvName,
          page: this.page_srv,
        };
        met = "srv_id";
      } else if (this.tabIndex == 1) {
        this.isLoadingSrvB = true;
        params = {
          ["search[srv_b_name]"]: this.searchSrvBName,
          page: this.page_srv_b,
        };
        met = "srv_b_id";
      } else if (this.tabIndex == 2) {
        this.isLoadingPrd = true;
        params = {
          ["search[prd_name]"]: this.searchProductsName,
          page: this.page_prd,
        };
        met = "prd_id";
      }

      let find = this.data_cars.findIndex(
        (r) => r["cst_crs_id"] == this.post.cst_crs_id
      );
      if (find != -1) {
        params["filter[crs_model_id]"] = this.data_cars[find].crs_model_id;
      } else {
        if (this.tabIndex == 0) {
          this.data_srv = null;
          this.page_srv = 1;
          this.limit = 10;
          this.totalData_srv = 0;
          this.total_page_srv = 0;
        } else if (this.tabIndex == 1) {
          this.data_srv_b = null;
          this.page_srv_b = 1;
          this.limit = 10;
          this.totalData_srv_b = 0;
          this.total_page_srv_b = 0;
        } else if (this.tabIndex == 2) {
          this.data_prd = null;
          this.page_prd = 1;
          this.limit = 10;
          this.totalData_prd = 0;
          this.total_page_prd = 0;
        }

        return false;
      }
      params["show"] = this.limit;
      this.axios
        .get("/dropdown/autocomplete/" + met, { params: params })
        .then((response) => {
          if (this.tabIndex == 0) {
            this.data_srv = response.data.data.data;

            if (this.data_srv.length > 0) {
              this.data_srv.forEach((element, key) => {
                let find = this.bindCheckOut.services.findIndex(
                  (r) => r["srv_id"] == element.srv_id
                );

                if (find >= 0) {
                  this.$set(
                    this.data_srv[key],
                    "srv_act_price",
                    this.bindCheckOut.services[find].srv_act_price
                  );

                  if (
                    typeof this.bindCheckOut.services[find]
                      .srv_price_est_external !== "undefined"
                  ) {
                    this.$set(
                      this.data_srv[key],
                      "srv_price_est_external",
                      this.bindCheckOut.services[find].srv_price_est_external
                    );
                  }

                  if (
                    typeof this.bindCheckOut.services[find]
                      .srv_price_act_external !== "undefined"
                  ) {
                    this.$set(
                      this.data_srv[key],
                      "srv_price_act_external",
                      this.bindCheckOut.services[find].srv_price_act_external
                    );
                  }

                  if (
                    typeof this.bindCheckOut.services[find].spr_id_select !==
                    "undefined"
                  ) {
                    this.$set(
                      this.data_srv[key],
                      "spr_id_select",
                      this.bindCheckOut.services[find].spr_id_select
                    );
                  }
                } else {
                  this.$set(
                    this.data_srv[key],
                    "srv_act_price",
                    element.srv_price
                  );
                }
              });
            }
            this.page_srv = response.data.data.current_page;
            this.totalData_srv = response.data.data.total_data;
            this.total_page_srv = response.data.data.total_page;
          } else if (this.tabIndex == 1) {
            this.data_srv_b = response.data.data.data;
            if (this.data_srv_b.length > 0) {
              this.data_srv_b.forEach((element, key) => {
                let find = this.bindCheckOut.services_bulk.findIndex(
                  (r) => r["srv_b_id"] == element.srv_b_id
                );

                if (find >= 0) {
                  this.$set(
                    this.data_srv_b[key],
                    "srv_b_act_price",
                    this.bindCheckOut.services_bulk[find].srv_b_act_price
                  );
                } else {
                  this.$set(
                    this.data_srv_b[key],
                    "srv_b_act_price",
                    element.srv_b_price
                  );
                }
              });
            }
            this.page_srv_b = response.data.data.current_page;
            this.totalData_srv_b = response.data.data.total_data;
            this.total_page_srv_b = response.data.data.total_page;
          } else if (this.tabIndex == 2) {
            this.data_prd = response.data.data.data;
            if (this.data_prd.length > 0) {
              this.data_prd.forEach((element, key) => {
                let find = this.bindCheckOut.products.findIndex(
                  (r) => r["prd_id"] == element.prd_id
                );

                if (find >= 0) {
                  this.$set(
                    this.data_prd[key],
                    "prd_act_price",
                    this.bindCheckOut.products[find].prd_act_price
                  );

                  this.$set(
                    this.data_prd[key],
                    "prd_total_price",
                    this.bindCheckOut.products[find].prd_total_price
                  );

                  if (
                    typeof this.bindCheckOut.products[find].prd_qty !==
                    "undefined"
                  ) {
                    this.$set(
                      this.data_prd[key],
                      "prd_qty",
                      this.bindCheckOut.products[find].prd_qty
                    );
                  }
                } else {
                  this.$set(
                    this.data_prd[key],
                    "prd_act_price",
                    element.prd_purchase
                  );

                  this.$set(
                    this.data_prd[key],
                    "prd_total_price",
                    element.prd_purchase
                  );

                  this.$set(this.data_prd[key], "prd_qty", 1);
                }
              });
            }
            this.page_prd = response.data.data.current_page;
            this.totalData_prd = response.data.data.total_data;
            this.total_page_prd = response.data.data.total_page;
          }

          this.isLoadingSrv = false;
          this.isLoadingSrvB = false;
          this.isLoadingPrd = false;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 500),
    searchEmploye() {},
    sumGrandTotal(value) {
      if (value != 0) {
        this.post.srv_t_actual_price =
          parseInt(this.sumTotal) - parseInt(value);
      }

      if (value == 0) {
        this.post.srv_t_actual_price = parseInt(this.sumTotal);
      }

      this.post.srv_t_estimated_price = this.post.srv_t_actual_price;
    },
    changeActual(value) {
      this.post.srv_t_actual_price = value;
      this.post.srv_t_estimated_price = value;
    },
    submit() {
      this.disabled = true;
      this.$set(this.post, "post_services", this.bindCheckOut.services);
      this.$set(
        this.post,
        "post_services_bulk",
        this.bindCheckOut.services_bulk
      );
      this.$set(this.post, "post_products", this.bindCheckOut.products);

      if (
        this.bindCheckOut.services.length == 0 &&
        this.bindCheckOut.services_bulk.length == 0
      ) {
        this.$set(this.post, "srv_t_status", 1);
      }

      if (
        this.bindCheckOut.services.length == 0 &&
        this.bindCheckOut.services_bulk.length == 0 &&
        this.bindCheckOut.products.length == 0
      ) {
        this.$toast.error("Pilih salah satu produk!!");
        return false;
      }

      this.axios
        .post("/" + this.table_module + "/saveAdmin", this.post)
        .then((response) => {
          if (response.data.status == 200) {
            this.disabled = false;
            this.$toast("Simpan data berhasil");
            this.$router.push({ name: this.table_module });
          }
        });
    },
    hideModal() {
      this.$refs["modal-customers"].hide();
    },
    hideModalCustomersCars() {
      this.$refs["modal-customers-cars"].hide();
    },
    getFieldsCustomers() {
      this.post_customers = {
        usr_role: 2,
      };
      this.axios.get("/users/create").then((response) => {
        let data = response.data.data;

        data.forEach((element, key) => {
          if(element.usr_f_name == 'usr_email')
          {
            data[key]['usr_f_validation'] = null;
          }
        });
        this.fields_customers = data;
      });
    },
    getFieldsCustomersCars() {
      var id = this.post_customers_cars.cst_id;
      this.post_customers_cars = {};
      this.$set(this.post_customers_cars, "cst_id", id);
      this.axios.get("/customers_cars/create").then((response) => {
        this.fields_customers_cars = response.data.data;
      });
    },
    bindingData: function (value) {
      if (value["value"] == null || value["value"] === "") {
        this.$delete(this.post, value["name"]);
      } else {
        if (value["name"] == "emp_id") {
          this.$set(this.post, value["name"], value["value"].emp_id);
          this.data_emp = value["value"];
        }
      }
    },
    bindingDataCustomers: function (value) {
      if (value["value"] == null || value["value"] == "") {
        this.$delete(this.post_customers, value["name"]);
      } else {
        this.$set(this.post_customers, value["name"], value["value"]);
      }
    },
    bindingDataCustomersCars: function (value) {
      if (value["value"] == null || value["value"] == "") {
        this.$delete(this.post_customers_cars, value["name"]);
      } else {
        this.$set(this.post_customers_cars, value["name"], value["value"]);
        if (value.name == "crs_brand_id") {
          this.trigger_autocomplete =
            Math.floor(100000 + Math.random() * 900000) + "_crs_model_id";
        }
      }
    },
    saveCustomers() {
      // this.$set(this.post_customers, 'cst_id', this.data_customers.usr_id);
      // this.data_customers.usr_id
      this.axios
        .post("/users/register_customers", this.post_customers)
        .then((response) => {
          if (response.data != "") {
            this.data_customers = response.data.data;
            this.$set(this.post, "cst_id", this.data_customers.usr_id);
            this.$set(
              this.post_customers_cars,
              "cst_id",
              this.data_customers.usr_id
            );
            this.getCustomersCars();
            this.hideModal();
          }
        })
        .catch((error) => {
          this.disabled = false;
          if (error.response.data.error != undefined) {
            this.error = error.response.data.error;
          } else {
            this.error = error.response.data;
          }
        });
    },
    saveCustomersCars() {
      this.axios
        .post("/customers_cars/save", this.post_customers_cars)
        .then((response) => {
          if (response.data != "") {
            this.data_cars.push(response.data.data.customers_cars);
            this.hideModalCustomersCars();
          }
        })
        .catch((error) => {
          this.disabled = false;
          if (error.response.data.error != undefined) {
            this.error = error.response.data.error;
          } else {
            this.error = error.response.data;
          }
        });
    },
    est_time(arm) {
      var res = "";
      if (arm != null) {
        var arr = arm.split(":");
        res += arr[0] + " Hours ";
        res += arr[1] + " Minutes";
      }
      return res;
    },
    startPaginateSrv: function (pageNum) {
      this.page_srv = pageNum;
      this.runServices();
    },
    startPaginateSrvB: function (pageNum) {
      this.page_srv_b = pageNum;
      this.runServices();
    },
    startPaginatePrd: function (pageNum) {
      this.page_prd = pageNum;
      this.runServices();
    },
    removeDataCheckout: function (module_rel = "", index, item) {
      if (module_rel == "services") {
        this.bindCheckOut.services.splice(index, 1);
        let find = this.data_srv.findIndex((r) => r["srv_id"] == item.srv_id);

        if (find != -1) {
          this.$set(this.data_srv[find], "srv_act_price", item.srv_price);
          delete this.data_srv[find]["spr_id_select"];
          delete this.data_srv[find]["srv_price_est_external"];
          delete this.data_srv[find]["srv_price_act_external"];
        }
      } else if (module_rel == "services_bulk") {
        this.bindCheckOut.services_bulk.splice(index, 1);
        let find = this.data_srv_b.findIndex(
          (r) => r["srv_b_id"] == item.srv_b_id
        );
        if (find != -1) {
          this.$set(this.data_srv_b[find], "srv_b_act_price", item.srv_b_price);
        }
      } else if (module_rel == "products") {
        this.bindCheckOut.products.splice(index, 1);
        let find = this.data_prd.findIndex((r) => r["prd_id"] == item.prd_id);
        if (find != -1) {
          this.$set(this.data_prd[find], "prd_act_price", item.prd_purchase);
          this.$set(this.data_prd[find], "prd_qty", 1);
          this.$set(
            this.data_prd[find],
            "prd_total_price",
            item.prd_total_price
          );
        }
      }

      this.getTotalPrice();
    },
    addVarBindChekcOut: function (evt, id, module_rel, name) {
      var value = "";
      // if (name == "srv_act_price" || name == "srv_price_act_external") {
      //   value = evt;
      // } else {
      //   value = evt.target.value;
      // }
      value = evt;

      if (module_rel == "services") {
        let find = this.data_srv.findIndex((r) => r["srv_id"] == id);

        if (find != -1) {
          this.$set(this.data_srv[find], name, value);
        }
      }

      if (module_rel == "services_bulk") {
        let find = this.data_srv_b.findIndex((r) => r["srv_b_id"] == id);

        if (find != -1) {
          this.$set(this.data_srv_b[find], name, value);
        }
      }

      if (module_rel == "products") {
        let find = this.data_prd.findIndex((r) => r["prd_id"] == id);

        if (find != -1) {
          this.$set(this.data_prd[find], name, value);

          let find_bind = this.bindCheckOut.products.findIndex(
            (r) => r["prd_id"] == id
          );

          if (find_bind != -1) {
            var price = this.bindCheckOut.products[find_bind]["prd_act_price"];
            var qty = this.bindCheckOut.products[find_bind]["prd_qty"];
            var total = price * qty;

            this.$set(this.data_prd[find], "prd_total_price", total);
            this.$set(
              this.bindCheckOut.products[find_bind],
              "prd_total_price",
              total
            );
          }
        }
      }

      this.getTotalPrice();
    },
    selectSupplier: function (evt, index, module_rel, item) {
      var value = evt.target.value;

      let find = this.bindCheckOut[module_rel][index].spr_id.findIndex(
        (r) => r["spr_id"] == value
      );

      if (find >= 0) {
        var srv_price_est_external = this.bindCheckOut[module_rel][index]
          .spr_id[find].srv_price_external;
        this.$set(
          this.bindCheckOut[module_rel][index],
          "srv_price_est_external",
          srv_price_est_external
        );
        this.$set(
          this.bindCheckOut[module_rel][index],
          "srv_price_act_external",
          srv_price_est_external
        );

        let find_data = this.data_srv.findIndex(
          (r) => r["srv_id"] == item.srv_id
        );

        if (find_data != -1) {
          this.$set(
            this.data_srv[find_data],
            "srv_price_est_external",
            srv_price_est_external
          );
          this.$set(
            this.data_srv[find_data],
            "srv_price_act_external",
            srv_price_est_external
          );
        }
      }
    },
    random_num() {
      Math.floor(100000000 + Math.random() * 900000000);
    },
  },
};
</script>